import { useEffect, useRef, useState, useCallback } from 'react'
import { SAside, SLowcodeList, STableActions, SActionBtn, SIDRender, SMessage} from 'shj-components'
import config from './config.json'
import styles from './index.module.less'
import { useNavigate } from 'react-router-dom'
import { AppstoreAddOutlined } from '@ant-design/icons'
import { modalAddOrEditFn } from './components/addOrEdit'
import { showModalTemplate } from './components/addOrEditPlan';
import {
  specialRulesLabelList, specialRulesLabelDelete, specialRulesLabelPageList,
  specialRulesDetailDelete, specialRulesDetailIsEnabled
} from '@/services/fmsConfig'
import { message, Alert, Spin, Skeleton } from 'antd'

export default function TreeSearchTable() {
  const listRef = useRef<any>();
  const navigate = useNavigate()
  const [treeData, setTreeData] = useState<any>([])
  const [defaultKeys, setDefaultKeys] = useState<any>([])
  const [orderVal, setOrderVal] = useState<any>(0)
  const [loading, setLoading] = useState<any>(false)
  const [spinning, setSpinning] = useState<any>(false)

  useEffect(() => {
    getTreeDataFn()
  }, [])

  const getTreeDataFn = () => {
    setLoading(false)
    specialRulesLabelList({ orderBys: [{ columnName: 'orderVal' }] }).then((res) => {
      const ruleList = res.map((item: any) => ({
        title: item.labelName,
        key: item.id,
        ...item
      }));
      setDefaultKeys(ruleList.length > 0 ? [ruleList[0].id] : [])
      setOrderVal(ruleList.length > 0 ? ruleList[0].orderVal : 0)
      setTreeData(ruleList)
      setLoading(true)
    })
  }
  //   左侧树节点事件
  const onChangeType = (node: any) => {
    setDefaultKeys(node)
    let editData = treeData.find((item) => item.id === node[0]);
    setOrderVal(editData.orderVal)
  }
  useEffect(() => {
    listRef.current?.reload()
  }, [defaultKeys])
  //   右侧数据查询
  const fetchList = values => {
    const { current, pageSize, ...rest } = values;
    return new Promise(async (resolve, reject) => {
      try {
        const { current, pageSize, query } = values
        query.labelId = defaultKeys.join(',')
        specialRulesLabelPageList(current, pageSize, query).then((res) => {
          resolve(res)
        })
      } catch (e) {
        reject({ success: false });
      }
    });
  }
  //   下拉选项加载
  const getOptions = async () => {
    const enabledList = [
      { label: '启用', key: true },
      { label: '禁用', key: false },
    ]
    return Promise.resolve({ enabledList })
  }
  const reload = () => {
    const {
      current: { reload },
    } = listRef
    reload()
  }
  const onAddOrEdit = (obj = {}) => {
    let addOrEditData = treeData.find((item) => item.id === obj.key); // 使用 find 方法获取匹配的项
    modalAddOrEditFn({
      fn: () => {
        getTreeDataFn()
      },
      ...addOrEditData,
    })
  }
  const onCopy = (record) => {
    onAdd({ ...record, showCopy: true });
  }
  const clickToDeatil = (record) => {
    onAdd({ ...record, disabled: true });
  }
  const onDel = (record: any) => {
    setSpinning(true)
    specialRulesLabelDelete(record.key).then((res: any) => {
      message.success(res?.message || '删除成功');
      getTreeDataFn();
      setSpinning(false)
    }).catch(err => {
      setSpinning(false)
    })
  }
  const onDetailDel = (record: any) => {
    setSpinning(true)
    specialRulesDetailDelete(record.id).then((res: any) => {
      message.success(res?.message || '删除成功');
      reload()
      setSpinning(false)
    }).catch(err => {
      setSpinning(false)
    })
  }
  const onAdd = (record: any) => {
    let fmsMainIds = ''
    if (record?.id) {
      fmsMainIds = record.fmsMainIds.split(',');
      const fileFields = ['fileUrl'];
      fileFields.forEach(field => {
        if (typeof record[field] === 'string' && record[field]) {
          record[field] = record[field].split(',').map((d: any, i: number) => getFileItem(d, i));
        }
      });
    }
    showModalTemplate({
      title: record?.showCopy ? '复制' : record?.disabled ? '查看' : record?.id ? '编辑' : '新增',
      fn: () => {
        // 处理关闭逻辑
        reload()
      },
      initialValues: { ...record, programmeId: defaultKeys.join(','), fmsMainIds: fmsMainIds !== '' ? fmsMainIds : [] },
    });
  };
  const handleStatusChange = useCallback((isStart: boolean, selectedRows: any[]) => {
    const list = selectedRows.map(m => m.id);
    specialRulesDetailIsEnabled({ specialRulesIds: list, isStart })
      .then((response: any) => {
        message.success(response?.message || '操作成功');
        reload();
      });
  }, []);

  const onDisable = useCallback(({ record, rows, selectedRows } = {}) => {
    handleStatusChange(false, selectedRows);
  }, [handleStatusChange]);

  const onEnable = useCallback(({ record, rows, selectedRows } = {}) => {
    handleStatusChange(true, selectedRows);
  }, [handleStatusChange]);

  const getFileItem = (item: any, i: number) => ({
    uid: i,
    name: item,
    status: 'done',
    url: 'https://shj-oso.obs.cn-north-4.myhuaweicloud.com/' + item,
    fullUrl: item,
  });
  const extensions = {
    request: { fetchList, getOptions },
    events: {
      onAdd, onEnable, onDisable,
    },
    status: {
      btnDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length <= 0,
    },
    customRender: {
      clueIdRender(text: any, record: any) {
        return (
          <SIDRender id={text} onClick={() => clickToDeatil(record)} copy={false}></SIDRender>
        )
      },
      actionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            {/* <SActionBtn onClick={() => clickToDeatil(record)}>查看</SActionBtn> */}
            <SActionBtn onClick={() => onAdd(record)}>编辑</SActionBtn>
            {
              record?.isEnable === 0 ? <SActionBtn danger confirm title={'确认删除'} onClick={() => onDetailDel(record)}>
                删除
              </SActionBtn> : null
            }
            <SActionBtn onClick={() => onCopy(record)}>复制</SActionBtn>
          </STableActions>
        )
      },
    },
  }
  return (<>
    <Skeleton loading={!loading} active>
      <Spin spinning={spinning}>
        <div className={styles.treeTable}>
          <div className={styles.leftMenu}>
            {/* 左侧树形选择 */}
            {
              loading ? <SAside
                treeData={treeData}
                onSelect={onChangeType}
                title={'方案'}
                treeType="tree"
                fieldNames={{ title: 'labelName', key: 'id' }}
                defaultSelectedKeys={defaultKeys}
                extra={[
                  { icon: <AppstoreAddOutlined />, tip: '新增', onClick: onAddOrEdit }
                ]}
                dropItems={[
                  {
                    label: '编辑',
                    onClick: (record) => {
                      onAddOrEdit(record)
                    },
                  },
                  {
                    label: <span style={{ color: '#f25a5a' }}>删除</span>,
                    onClick: (record) => {
                      let dialog = SMessage.delete({
                        onOk: () => {
                          onDel(record)
                          dialog?.destroy();
                        },
                        onCancel: () => {
                          dialog?.destroy();
                        },
                      });
                    },
                  },
                ]}
              /> : null
            }
          </div>
          {/* 右侧表格数据 */}
          {
            defaultKeys && defaultKeys.length !== 0 ? <div className={styles.rightTable}>
              <Alert style={{ margin: '15px 15px 0 15px' }} message={"方案优先级：" + orderVal} type="info" showIcon />
              <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
            </div> : null
          }
        </div>
      </Spin>
    </Skeleton>
  </>
  )
}
